import { ButtonIcon, ModalHeader, Typography } from '@statsbomb/kitbag-components';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router-dom';
import { userConfigActionAtom } from '@/atoms/userConfigs';
import { useRadarTemplateSteps } from '@/hooks/radar/useRadarTemplateSteps';

export const CreateRadarTemplateModalHeader = ({
  activeStep,
  onCancel,
}: {
  activeStep: number;
  onCancel: () => void;
}) => {
  const { t } = useTranslation(['modal', 'general']);
  const steps = useRadarTemplateSteps();
  const isPlayerSection = !!useMatch('/:locale/player/*');
  const entity = isPlayerSection ? 'player' : 'team';
  const userConfigAction = useAtomValue(userConfigActionAtom);
  const action = t(userConfigAction!, { ns: 'general' });

  return (
    <ModalHeader id="create-custom-radar-modal">
      {/* desktop header */}
      <Typography variant="headingRegular" className="hidden md:block" as="span">
        {t(`createRadarTemplateModal.title.${entity}`, { action })}
      </Typography>
      {/* mobile header */}
      <Typography variant="headingMedium" className="md:hidden" as="span">
        {t(`createRadarTemplateModal.mobile.title.${entity}`, {
          action,
          label: t(`createRadarTemplateModal.step${activeStep + 1}.label`),
          count: activeStep + 1,
          steps: steps.length,
          interpolation: { escapeValue: false },
        })}
      </Typography>
      <ButtonIcon icon="Close" onClick={onCancel} variant="ghost" size="small">
        {t('close', { ns: 'general' })}
      </ButtonIcon>
    </ModalHeader>
  );
};
